import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { filter, mergeMap, takeUntil } from 'rxjs/operators';
import { AccessRequirement } from '@app/core/models/access-requirement.model';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { UserService } from '@app/core/services/user.service';
import { UserDashboardModel } from '@app/core/models/users/user-dashboard.model';
import { UserProfileModel } from '@app/core/models/users/user-profile.model';
import { ConfigService } from '@app/core/config/config.service';

@Component({
  selector: 'app-tiles-menu',
  templateUrl: './tiles-menu.component.html',
  styleUrls: ['./tiles-menu.component.css'],
})
export class TilesMenuComponent implements OnInit, OnDestroy {
  hasOperationalGrant: boolean;
  hasValidationGrant: boolean;
  hasNonErpGrant: boolean;
  hasSupervisionGrant: boolean;
  hasAdministrationGrant: boolean;
  hasControlGrant: boolean;
  hasControlGrantNotPPR: boolean;
  hasObservationGrant: boolean;
  hasAnalyticalGrant: boolean;
  hasOperationContributorGrant: boolean;
  hasPPRValidationGrant: boolean;

  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  dashboard: UserDashboardModel;

  version: string;
  academie: string;

  constructor(
    private userService: UserService,
    private config: ConfigService,
    private authenticationInfoService: AuthenticationInfoService
  ) {}

  ngOnInit() {
    this.version = this.config.environnement.version;
    this.academie = this.config.environnement.academieURL;
    this.authenticationInfoService.userProfileLoaded$
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((userProfile) => !_.isNil(userProfile))
      )
      .subscribe((userProfile: UserProfileModel) => {
        this.hasOperationalGrant = userProfile.hasGrant(
          AccessRequirement.OperationalMembership
        );
        this.hasValidationGrant = userProfile.hasGrant(
          AccessRequirement.ValidationMembership
        );
        this.hasNonErpGrant = userProfile.hasGrant(
          AccessRequirement.NonErpMemberShip
        );
        this.hasSupervisionGrant = userProfile.hasGrant(
          AccessRequirement.SupervisionMembership
        );
        this.hasAdministrationGrant = userProfile.hasGrant(
          AccessRequirement.AdministrationMembership
        );
        this.hasControlGrant = userProfile.hasGrant(
          AccessRequirement.ControlMembership
        );
        this.hasControlGrantNotPPR = userProfile.hasGrant(
          AccessRequirement.ControlNotPPRMembership
        );
        this.hasObservationGrant = userProfile.hasGrant(
          AccessRequirement.ObservationMembership
        );
        this.hasAnalyticalGrant = userProfile.hasGrant(
          AccessRequirement.AnalyticalMembership
        );
        this.hasOperationContributorGrant = userProfile.hasGrant(
          AccessRequirement.OperationContributorMembership
        );
        this.hasPPRValidationGrant = userProfile.hasGrant(
          AccessRequirement.PPRValidationMembership
        );
      });

    this.authenticationInfoService.userLoggedIn$
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((isAuthentified: boolean) => isAuthentified),
        mergeMap((_) => this.userService.getUserDashboard())
      )
      .subscribe((dashboard: UserDashboardModel) => {
        this.dashboard = dashboard;
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
